import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// Yeni bir sayfaya gecildiginde sayfayi en basa alir.
//
// React Router tek sayfa uygulamasi oldugu icin gezinti sirasinda tarayici
// kaydirma konumunu korur; urun listesinin ortasindan bir urune tiklayinca
// yeni sayfa da ortadan acilir. Bu bilesen her adres degisiminde en uste doner.
//
// Ayni sayfada sadece arama parametresi degistiginde (filtreleme gibi)
// kaydirmayi bozmamak icin yalnizca pathname degisimini dinler.
const ScrollToTop: React.FC = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
  }, [pathname]);

  return null;
};

export default ScrollToTop;
